import { IdFormat } from '../'
import { branch } from '../constants'

module.exports = () ->
  { className } = IdFormat
  configNode = new Weaver.Node(className)
  configNode.set('name', className)
  await configNode.save({ branch, commitMessage: "Add Id Format Migration." })
  idFormat = new IdFormat()
  idFormat.setIdType('uuid', { branch })
  await idFormat.save({ branch })
